import uploadshomeherobgimage556139670HomepageHeroMainBJpg from "$lib/data/generated/uploads/home/Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg";
import uploadshomeheroimagethomasMoore2Png from "$lib/data/generated/uploads/home/Hero/image/Thomas-Moore2.png";

export const uploads = {
  "uploads/home/Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg": uploadshomeherobgimage556139670HomepageHeroMainBJpg,
  "uploads/home/Hero/image/Thomas-Moore2.png": uploadshomeheroimagethomasMoore2Png
};